import React from "react";
import "./Gallery.css";

const images = [
  "/gallery1.webp",
  "/gallery2.webp",
  "/gallery3.webp",
  "/gallery4.webp",
  "/gallery5.webp",
  
];

const GallerySection = () => {

  return (
    <section className="gallery-section">
      <div className="backdiv">
      <div className="gallery-header">
        <h2 className="sapt-head-white text-center">MEMORIES</h2>
      </div>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div
            className="gallery-card"
            key={index}
          >
            <img className="img-cover" src={img} alt="gallery" loading="lazy"/>
          </div>
        ))}
      </div>

     
      </div>
    </section>
  );
};

export default GallerySection;
